<!--CFS > Scan Pack-->
<template>
  <div>
    <a-drawer :title="fieldMap.lbSplitScan.displayName" @close="onClose" :visible="visible" width="95%"
      :maskClosable="false" style="margin: 0px 0 0 10px">
      <a-row type="flex" justify="start" style="margin: 10px 0 0 0">
        <a-col v-for="item in btnFunArr" :key="item.uid">
          <div v-if="item.code == 'Query'" >
            <a-button
                v-if="item.arr.length == 1"
                size="small" type="primary"
                @click="queryHandler()">
              {{item.arr[0].name}}
            </a-button>
          </div>
        </a-col>
        <a-col v-for="item in btnFunArr" :key="item.uid">
          <div v-if="item.code == 'Delete'" style="margin-left: 4px;" >
            <a-button
                v-if="item.arr.length == 1"
                size="small" type="primary"
                @click="removeHandler()">
              {{item.arr[0].name}}
            </a-button>
          </div>
        </a-col>
        <a-col v-for="item in btnFunArr" :key="item.uid">
          <div v-if="item.code == 'Export'" style="margin-left: 4px;">
            <a-button
                v-if="item.arr.length == 1"
                size="small" type="primary"
                @click="exportExcel()">
              {{item.arr[0].name}}
            </a-button>
          </div>
        </a-col>

      </a-row>
      <a-row type="flex" justify="start" style="margin: 10px 0 0 10px">
        <a-col>
            <div style="width: 100px;font-weight: bold">{{ this.fieldMap.lbWaveNo.displayName }}</div>
        </a-col>
      </a-row>
      <a-row type="flex" justify="start" style="margin: 10px 0 0 10px">
        <a-col>
          <a-input style="width: 150px" ref="waveNoRef" :placeholder="$t('publicLang.PleaseEnter')"
                   v-model="waveNoVal" size="small" @pressEnter="queryHandler"  />
        </a-col>

      </a-row>
      <a-divider style="margin: 10px 0"></a-divider>

      <a-row>
        <vxe-table border :data.sync="tableList" ref="skuTable" class="mytable-style" :cell-class-name="cellClassName" :row-style="rowStyle"
          max-height="280" size="mini">
          <template v-slot:empty>
            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
          </template>
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column field="sortNumber" :title="fieldMap.tbNumber.displayName" show-header-overflow="ellipsis"
            show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="relId" :title="fieldMap.tbOrderNo.displayName" show-header-overflow="ellipsis"
            show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="sku" :title="fieldMap.tbSku.displayName" show-header-overflow="ellipsis"
            show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="orderQty" :title="fieldMap.tbOrderQty.displayName" show-header-overflow="ellipsis"
            show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="scanQty" :title="fieldMap.tbScanQty.displayName" show-header-overflow="ellipsis"
            show-overflow="ellipsis"></vxe-table-column>
          <vxe-table-column field="upc" :title="fieldMap.tbBarcode.displayName" show-header-overflow="ellipsis"
                            show-overflow="ellipsis"></vxe-table-column>
        </vxe-table>
      </a-row>

      <a-row class="mt">
        <!--左侧-->
        <a-col :span="8" style="marginTop:6px">
          <a-row>
            <div style="width: 100px;font-weight: bold;margin: 0px 0 0 10px">{{ this.fieldMap.tbNumber.displayName }}</div>
            <div style="display: block; text-align: center;">
              <i :style="{fontSize:setFontSize(this.leftNumber), color: 'red'}">{{ leftNumber }}</i>
            </div>


          </a-row>

        </a-col>

        <!--右侧-->
        <a-col :span="16" style="float: right">
          <a-row type="flex" justify="start" style="margin: 0px 0 0 0">
            <a-col v-for="item in btnFunArr" :key="item.uid">
                <div v-if="item.code == 'LockFocus'" style="">
                  <a-button size="small" type="primary" @click="lockFocus">
                    {{item.arr[0].name}}
                  </a-button>
                </div>
            </a-col>
            <a-col v-for="item in btnFunArr" :key="item.uid">
                <div v-if="item.code == 'UnLockFocus'" style="margin-left: 4px;">
                  <a-button size="small" type="primary" @click="unlockFocus">
                    {{item.arr[0].name}}
                  </a-button>
                </div>
            </a-col>
            <a-col v-for="item in btnFunArr" :key="item.uid">
                <div v-if="item.code == 'Confirm'" style="margin-left: 4px;">
                  <a-button size="small" type="primary" @click="fixOnHandler1">
                    {{item.arr[0].name}}
                  </a-button>
                </div>
            </a-col>
          </a-row>

          <a-row type="flex" justify="start" style="margin: 10px 0 0 0px">
            <a-col>
              <div style="width: 100px;font-weight: bold">{{this.fieldMap.lbSkuCode.displayName}}</div>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-input style="width: 300px;" v-model="skuCode" size="small" ref="skuCodeRef" @pressEnter="fixOnHandler1" @paste="handlePaste"/>
              <a-checkbox v-model="autoRefreshFlag" size="large" style="margin-left: 20px" @change="autoRefreshFlagChange"></a-checkbox>
              <span style="margin-left: 8px; vertical-align: middle;">{{ this.fieldMap.lbAutoRefreshList.displayName }}</span>
            </a-col>
          </a-row>


          <a-row type="flex" justify="start" style="margin: 20px 0 0 0;">
            <a-col :span="21" style="border: 1px solid #ccc">
              <a-row type="flex" justify="start">
                <a-col :span="8">
                  <a-row type="flex" justify="start" style="margin: 10px 0 0 0;font-weight: bold;">
                      <span style="margin-left: 8px; vertical-align: middle;">{{ this.fieldMap.lbTotalQty.displayName }}</span>

                  </a-row>
                  <a-row style="margin: 10px;">
                    <div style="width: 100%; height: 180px; border: 1px solid #D3D3D3; background-color: #F5F5F5; display: flex; align-items: center; justify-content: flex-end;">
                      <i :style="{fontSize:setRightFontSize(this.toTalQty), color: 'black'}">{{ toTalQty }}</i>
                    </div>
                  </a-row>

                </a-col>
                <a-col :span="8">
                  <a-row type="flex" justify="start" style="margin: 10px 0 0 0;font-weight: bold;">
                    <span style="margin-left: 8px; vertical-align: middle;">{{ this.fieldMap.lbScanQty.displayName }}</span>

                  </a-row>
                  <a-row style="margin: 10px;">
                    <div style="width: 100%; height: 180px; border: 1px solid #D3D3D3; background-color: #F5F5F5; display: flex; align-items: center; justify-content: flex-end;">
                      <i :style="{fontSize:setRightFontSize(this.scanQty), color: 'black'}">{{ scanQty }}</i>
                    </div>
                  </a-row>
                </a-col>
                <a-col :span="8">
                  <a-row type="flex" justify="start" style="margin: 10px 0 0 0;font-weight: bold;">
                    <span style="margin-left: 8px; vertical-align: middle;">{{ this.fieldMap.lbDiffQty.displayName }}</span>

                  </a-row>
                  <a-row style="margin: 10px;">
                    <div style="width: 100%; height: 180px; border: 1px solid #D3D3D3; background-color: #F5F5F5; display: flex; align-items: center; justify-content: flex-end;">
                      <i :style="{fontSize:setRightFontSize(this.differenceQty), color: 'red'}">{{ differenceQty }}</i>
                    </div>
                  </a-row>
                </a-col>
              </a-row>




            </a-col>


            <a-col :span="3">

            </a-col>
          </a-row>

          <a-row type="flex" justify="start" style="margin: 10px 0 0 0;">
            <a-col :span="24">
              <span style="display: inline-block; width: 100px; margin-left: 8px; vertical-align: middle; font-size: 16px;">{{ this.fieldMap.lbScanTime.displayName }}</span>
              <span style="margin-left: 8px; vertical-align: middle; font-size: 16px">{{scanTime}}</span>
            </a-col>
          </a-row>

          <a-row type="flex" justify="start" style="margin: 20px 0 0 0;">
            <a-col :span="24">
              <span style="display: inline-block; width: 100px;margin-left: 8px; vertical-align: middle; font-size: 16px;">{{this.fieldMap.lbSkuCode.displayName}}</span>
              <span style="margin-left: 8px; vertical-align: middle; font-size: 16px">{{alreadyScanSku}}</span>
            </a-col>
          </a-row>



        </a-col>
      </a-row>
    </a-drawer>

    <audio v-if="showSound" controls="controls" autoplay="autoplay" id="loadSound" hidden>
      <source src="../../../assets/mm.mp3" type="audio/mpeg" />
    </audio>

    <audio ref="audioPlayer" preload="auto"></audio>

  </div>
</template>
<script>
  import ajax from "../../../api/ajax";
  import api from "../../../api/url";
  import axios from "axios";
  import {
    mapState
  } from "vuex";
  export default {
    data() {
      return {
        form: this.$form.createForm(this),
        visible: false,
        tableList: [], //列表数据集合
        selectRow: "", // 父表当前选中行用来样式
        showSound: false, //显示声音控件

        fieldMap: {
          lbSplitScan: {},
          lbWaveNo:{},
          tbOrderNo:{},
          tbSoNo:{},
          tbSku:{},
          tbOrderQty:{},
          tbScanQty:{},
          tbBarCode:{},
          tbProviderBarCode:{},
          lbOrderNo:{},
          btQuery:{},
          btDel:{},
          btLockFocus:{},
          btUnLock:{},
          btConfirm:{},
          lbSKu:{},
          lbAutoRefrsh:{},
          lbTOtalQty:{},
          lbScanQty:{},
          lbScanTime:{},
          tbNumber:{},
          tbBarcode:{},
          lbAutoRefreshList:{},
          lbTotalQty:{},
          lbSkuCode:{},
          lbDiffQty:{},
        },
        btnFunArr: [
          {code: 'Query',arr:[{name:""}]},
          {code: 'Delete',arr:[{name:""}]},
          {code: 'Export',arr:[{name:""}]},
          {code: 'LockFocus',arr:[{name:""}]},
          {code: 'UnLockFocus',arr:[{name:""}]},
          {code: 'Confirm',arr:[{name:""}]},
        ],
        autoRefreshFlag: true,
        scanTime: '',
        skuCode:'',
        waveNoVal: "",
        leftNumber:"",
        toTalQty:0,
        scanQty:0,
        differenceQty:0,
        inputValue: '',
        isFocusLocked: false,
        focusLockTimer: null,
        alreadyScanSku:"",
        pb_selectList:[],

      }
    },
    computed: {
      setFontSize() {
        return function (val) {
          let size = 100;
          val = val + '';
          if (val.length == 1) {
            size = 260;
          } else if (val.length == 2) {
            size = 220;
          } else if (val.length == 3) {
            size = 180;
          } else if (val.length == 4) {
            size = 140;
          }
          return size + 'px';
        }
      },
      setRightFontSize() {
        return function (val) {
          let size = 100;
          val = val + '';
          if (val.length == 1) {
            size = 140;
          } else if (val.length == 2) {
            size = 120;
          } else if (val.length == 3) {
            size = 100;
          } else if (val.length == 4) {
            size = 80;
          }
          return size + 'px';
        }
      }
    },
    watch: {

    },
    mounted() {
      document.addEventListener('focusin', this.handleFocusIn);
    },
    beforeDestroy() {
      document.removeEventListener('focusin', this.handleFocusIn);
      this.clearFocusTimer();
    },
    methods: {
      checkObjIsNotEmpty(obj) {
        if (obj != undefined && obj != null && obj != '' ) {
          return true;
        }
        return false;
      },
      checkObjIsEmpty(obj) {
        if (obj == undefined || obj == null || obj == '' ) {
          return true;
        }
        return false;
      },
      queryHandler() {
        if(this.waveNoVal != null && this.waveNoVal != ''){
          this.waveNoSearch();
        } else {
          this.audioPubFun();
          this.$customMessage.warning(this.$t('splitScan.queryConditionCantBeNull'));
          return;
        }
      },
      waveNoSearch() {
        let params = {};
        params.waveNo = this.waveNoVal;
        ajax.post(api.SPLITSCANQUERY, params).then(res => {
          if (res.code == 200) {
            this.tableList = res.data;
            this.toTalQty = 0;
            this.scanQty = 0;
            for (let index in res.data) { //统计已扫描,未扫描数量
              this.toTalQty += parseInt(res.data[index]['orderQty']);
              this.scanQty += parseInt(res.data[index]['scanQty']);
            }
            this.differenceQty = this.toTalQty - this.scanQty;
          } else {
            this.audioPubFun();
            this.$customMessage.warning(res.msg);
          }
        })
      },
      // ======================================= lockFocus start =======================================
      lockFocus() {
        this.isFocusLocked = true;
        this.forceFocus();
      },
      unlockFocus() {
        this.isFocusLocked = false;
        this.clearFocusTimer();
      },
      forceFocus() {
        this.$refs.skuCodeRef.focus();
        // 使用定时器确保焦点持续锁定
        this.clearFocusTimer();
        this.focusLockTimer = setInterval(() => {
          if (this.isFocusLocked && document.activeElement !== this.$refs.skuCodeRef) {
            this.$refs.skuCodeRef.focus();
          }
        }, 100);
      },
      handleFocusIn(event) {
        if (this.isFocusLocked && event.target !== this.$refs.skuCodeRef) {
          // 阻止非输入框元素获得焦点
          event.preventDefault();
          this.$refs.skuCodeRef.focus();
        }
      },
      clearFocusTimer() {
        if (this.focusLockTimer) {
          clearInterval(this.focusLockTimer);
          this.focusLockTimer = null;
        }
      },
      // ======================================= lockFocus end =======================================
      fixOnHandler1() {
        if(this.checkObjIsEmpty(this.waveNoVal)) {
          this.audioPubFun();
          this.$customMessage.warning(this.$t('splitScan.queryConditionCantBeNull'));
          return;
        }
        if(this.checkObjIsEmpty(this.skuCode)) {
          this.audioPubFun();
          this.$customMessage.warning(this.$t('splitScan.skuCannotBeEmpty'));
          return;
        }

        this.alreadyScanSku = "";
        this.scanTime = "";
        if(this.tableList == null || this.tableList.length == 0) {
          this.audioPubFun();
          this.$customMessage.warning(this.$t('splitScan.noUnreviewedProductsExist'));
          return;
        }


        this.alreadyScanSku = this.skuCode;
        this.scanTime = this.formatDateTime(new Date());;
        let params = {};
        params.waveNo = this.waveNoVal;
        params.sku = this.skuCode;

        this.skuCode = "";
        ajax.post(api.SPLITSCANSCAN, params).then(res => {
          if (res.code == 200) {
            if(this.autoRefreshFlag) {
              this.tableList = res.data.splitScanDtos;
            }

            this.toTalQty = 0;
            this.scanQty = 0;
            this.leftNumber = res.data.orderNumber;
            for (let index in res.data.splitScanDtos) { //统计已扫描,未扫描数量
              this.toTalQty += parseInt(res.data.splitScanDtos[index]['orderQty']);
              this.scanQty += parseInt(res.data.splitScanDtos[index]['scanQty']);
            }
            this.differenceQty = this.toTalQty - this.scanQty;

            this.playAudio();
          } else {
            this.alreadyScanSku = '';
            this.audioPubFun();
            this.$customMessage.warning(res.msg);
          }
        })

      },
      formatDateTime(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
      },

      removeHandler() {
        this.pb_selectList = this.$refs.skuTable.getSelectRecords();
        if (this.pb_selectList.length < 1) {
          this.audioPubFun();
          this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
          return;
        }

        let that = this;
        this.$customConfirm({
          title: that.$t('generic.AreyoudeleTask'),
          content: "",
          onOk() {
            ajax.post(api.SPLITSCANREMOVE, that.pb_selectList).then(res => {
              if (res.code === 200) {
                that.$message.success(res.msg);
                that.queryHandler();
              } else {
                that.audioPubFun();
                that.$customMessage.warning(res.msg);
                return;
              }
            });
          }
        });



      },
      exportExcel() {
        if(this.waveNoVal != null && this.waveNoVal != ''){
        } else {
          this.audioPubFun();
          this.$customMessage.warning(this.$t('splitScan.queryConditionCantBeNull'));
          return;
        }

        let params = {};
        params.waveNo = this.waveNoVal;
        let ajaxurl = ajax.ajaxUrl();
        ajax.exportExcel(ajaxurl+api.SPLITSCANEXPORTEXCEL, params).then(data => {
          if (!data) {
            return;
          }
          let type = data.data.type;
          let that = this;
          const relType = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
          if( type.includes('application/json')){
            let reader = new FileReader()
            reader.onload = function (event) {
              let content = reader.result
              let msg = JSON.parse(content).msg
              that.$customMessage.warning(msg);
            }
            reader.readAsText(data.data)
            return
          }else{
            var blob = new Blob([data.data], {
              type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
            });
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.href = url;
            aLink.setAttribute("download", "excel.xlsx");
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        }).catch(function(error) {
          alert(error);
        })


      },

      playAudio() {
        if(this.checkObjIsEmpty(this.leftNumber)) {
          return;
        }
        const audioPlayer = this.$refs.audioPlayer;
        // 设置音频源为对应数字的MP3文件（更新路径）
        audioPlayer.src = `/assets/splitScanSounds/${this.leftNumber}.mp3`;

        // 加载并播放音频
        audioPlayer.load();
        audioPlayer.play().catch(error => {
          console.error('播放音频失败:', error);
        });
      },



      //            关闭弹窗
      onClose() {
        this.visible = false;
      },

      //            打开弹窗
      show() {
        this.visible = true;
        this.btnFunArr= [
          /*{code: 'Query',arr:[{name:""}]},
          {code: 'Delete',arr:[{name:""}]},
          {code: 'Export',arr:[{name:""}]},
          {code: 'LockFocus',arr:[{name:""}]},
          {code: 'UnLockFocus',arr:[{name:""}]},
          {code: 'Confirm',arr:[{name:""}]},*/
        ]

        let that = this;
        ajax.get(api.GENERICPRINTNODEALLBTNFORLOAD,{module_code:"SPLIT_SCAN"}).then(res=>{
          this.fieldMap = res.data.fieldMap;
          let btnMap = res.data.behrMap;

          if (btnMap != null ) {
            // 遍历 Map，判断值是否为 null
            for (let key in  btnMap) {
              if (btnMap[key] !== null) {
                console.log(btnMap[key]);
                that.btnFunArr.push({
                  code: key,
                  arr: btnMap[key]
                });
              }
            }
          }
        })
        this.waveNoVal="";
        this.skuCode = "";
        this.autoRefreshFlag = true;
        this.tableList = [];
        this.toTalQty = 0;
        this.scanQty = 0;
        this.differenceQty = 0;
        this.leftNumber = "";
        this.scanTime = "";
        this.alreadyScanSku = "";

        this.$nextTick(()=>{
          this.$refs.waveNoRef.focus();
        })
        this.clearFocusTimer();
      },





      //            播放提示声
      audioPubFun() {
        this.showSound = true;
        let audio = document.getElementById("loadSound");
        if (audio !== null) {
          if (audio.paused) {
            audio.play();
          } else {
            audio.pause();
          }
        }
      },

      //            表格样式
      cellClassName({
        row
      }) {
        if (row === this.selectRow) {
          return "col-orange";
        }
      },
      rowStyle ({ row }) {
        if(row.orderQty >  row.scanQty){
          return {
            color: 'red'
          }
        }
      },

      autoRefreshFlagChange() {
        if(this.autoRefreshFlag) {
          this.queryHandler();
        }
      },

      handlePaste(e) {
        // 阻止默认粘贴行为
        e.preventDefault();

        // 获取剪贴板数据
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedText = clipboardData.getData('text');

        // 去除所有空格
        this.skuCode = pastedText.replace(/\s+/g, '');
      }
    }
  };
</script>
<style lang="less">
  .ant-btn-group>.ant-btn:first-child:not(:last-child),
  .ant-btn-group>span:first-child:not(:last-child)>.ant-btn {
    border: 0px;
  }

  .ant-dropdown-button>.ant-btn-default {
    padding: 0 7px;
    font-size: 14px;
    border-radius: 4px;
    height: 24px;
  }

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }

  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }

  .scanCodeTile {
    font-size: 16px;
    text-align: center;
  }

  .radius {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 330px;
    height: 330px;
    border-radius: 50%;

    i {
      color: #fff;
    }
  }

  .scanpackHeader {
    display: flex;
    align-items: center;
    justify-content: left;
  }

  .scanpackTitle {
    font-size: 12px;
    margin: 0 10px;
    width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }

  .slide-fade-enter-active {
    transition: all 0.1s ease;
  }

  .slide-fade-leave-active {
    transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter,
  .slide-fade-leave-to

  /* .slide-fade-leave-active for below version 2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
  }

  .mytable-style .vxe-body--row.row-green {
    background-color: darkseagreen;
    color: #333;
  }

  .existDataStyle {
    width: 80%;
    height: 120px;
    margin-top: 5px;
    padding-top: 40px;
    text-align: center;
    color: white;
    font-size: 100px;
  }

  .noDataStyle {
    width: 80%;
    height: 120px;
    margin-top: 5px;
    padding-top: 40px;
  }
</style>